import {inject, Injectable} from "@angular/core";
import {HttpClient} from "@angular/common/http";
import {UrlBuilder} from "../item/url.item";
import {map} from "rxjs/operators";
import {WrapperDto} from "../dto/wrapper.dto";
import {KeyValueDto} from "../dto/key-value.dto";
import {StorageService} from "../../services/storage/storage.service";
import {Observable} from "rxjs";
import {nonBlank} from "../../libs/utils/epic.utils";

@Injectable({providedIn: 'root'})
export class I18nRepo {

  private readonly expire12h = 60 * 60 * 12; // 12h
  private readonly countriesStorageKey = 'countries';
  private readonly timezonesStorageKey = 'timezones';
  private readonly sectorsStorageKeyPrefix = 'sectors:';
  private readonly countriesRead = '/v1/i18n/country';
  private readonly timezonesRead = '/v1/i18n/timezone';
  private readonly sectorsRead = '/v1/i18n/sector';

  protected readonly http: HttpClient = inject(HttpClient);
  private readonly storageService: StorageService = inject(StorageService);

  public getCountries(): Observable<WrapperDto<KeyValueDto>> {
    return this.storageService.cache(this.countriesStorageKey,
      () => {
        const url = UrlBuilder.builder().addPath(this.countriesRead).build();
        return this.http.get<WrapperDto<KeyValueDto>>(url.getUrl(), url.getOptions());
      }, this.expire12h
    ).pipe(map((res) => new WrapperDto(res)));
  }

  public getTimezones(): Observable<WrapperDto<KeyValueDto>> {
    return this.storageService.cache(this.timezonesStorageKey,
      () => {
        const url = UrlBuilder.builder().addPath(this.timezonesRead).build();
        return this.http.get<WrapperDto<KeyValueDto>>(url.getUrl(), url.getOptions());
      }, this.expire12h
    ).pipe(map((res) => new WrapperDto(res)));
  }

  public getSectors(filterCountryCode?: string): Observable<WrapperDto<KeyValueDto>> {
    const storageKey = this.sectorsStorageKeyPrefix + (nonBlank(filterCountryCode) ? filterCountryCode : 'all');
    return this.storageService.cache(storageKey,
      () => {
        let urlBuilder = UrlBuilder.builder().addPath(this.sectorsRead);
        if (nonBlank(filterCountryCode)) {
          urlBuilder = urlBuilder.addQueryParams('filterCountryCode', filterCountryCode);
        }
        const url = urlBuilder.build();
        return this.http.get<WrapperDto<KeyValueDto>>(url.getUrl(), url.getOptions());
      }, this.expire12h
    ).pipe(map((res) => new WrapperDto(res)));
  }
}
